import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { TournamentService } from 'src/app/services/tournaments/tournament.service';
import { filter, map, mergeMap, switchMap, take, takeUntil } from 'rxjs/operators';
import { CommonTournament, Tournament } from 'src/app/services/tournaments/tournaments.models';
import { environment } from 'src/environments/environment';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { missionsTrx, tournamentsTrx } from 'src/app/router-translation.labels';
import { combineLatest, of } from 'rxjs';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import { MissionService } from 'src/app/services/missions/mission.service';
import { Mission } from 'src/app/services/missions/missions.models';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { SwiperConfiguration } from 'src/app/components/games/search-game/swiper-module/swiper-config.model';

export const swiperConfig: SwiperConfiguration = {
  swiperWrapper: {
    gap: '32px',
  },
  swiperBodyWrapper: {
    height: '420px',
    gap: '16px',
    aliginItems: 'flex-start',
  },
  
  swipeToMove: 1,
  loop: true,
}

@Component({
  selector: 'app-home-page-missions',
  templateUrl: './home-page-missions.component.html',
  styleUrls: ['./home-page-missions.component.scss']
})
export class HomePageMissionsComponent extends BasePageComponent {
  constructor(
    private missionService: MissionService,
    private loginStatus: LoginStatusService,
    protected translationConfig: TranslationConfig,
    @Inject(LOCALE_ID) public locale: string,
    public licenceService: LicenceService
  ) { super() }
  // @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: false,
    scrollbar: false,
    // navigation: <SwiperNavigationInterface>{
    //   nextEl: '.button-next',
    //   prevEl: '.button-prev'
    // },
    keyboard: true,
    freeMode: false,
    slidesPerView: 3,
    slidesPerGroup: 1,
    centerInsufficientSlides: false,
    centeredSlides: false,
    loop: false,
    spaceBetween: 10,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax: true,
  };

  enableTournamentsDisplay = environment.enableTournamentsDisplay;
  mission: Mission[] = [];
  startDate = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
  // activeTournaments: TournamentWithCountDown[] = [];
  offset = new Date().getTimezoneOffset();
  numberTournaments = 0;
  public missionsTrx = this.translationConfig.getTranslation(missionsTrx);
  public swiperConfig = swiperConfig;

  ngOnInit(): void {
    this.loginStatus.getLoginStatus().pipe(
      filter(status => status.isLogged !== LoggedStatus.voidState),
      switchMap((status) => {
        return this.missionService.updateMissionsStore().pipe(
          map(tournaments => ({ tournaments, isLogged: status.isLogged === LoggedStatus.logged }))
        )
      }),
      takeUntil(this.unsubscribe)
    ).subscribe(resp => {
      this.numberTournaments = resp.tournaments.length;
      this.mission = resp.tournaments;
      if(!resp.isLogged){
        this.mission = this.mission.filter(x=>!x.isPrizeEngineEligiblePlayers)
      }
      if (resp.isLogged) {
        // this.missionService.getPrivateTournaments().pipe(take(1)).subscribe(respPrivate => {
        //   this.numberTournaments = respPrivate.length;
        //   this.mission = respPrivate;
        // })
      }
    })
  }

  next() {
    this.componentRef.swiperRef.slideNext();
  }

  prev() {
    this.componentRef.swiperRef.slidePrev();
  }

}
